import { Check } from "lucide-react";
import { IAdminRole } from "@/services/admin-management-service";
import { PERMISSION_MATRIX, type AdminModule, type PermissionAction } from "@/lib/permissions";

const PERMISSIONS_LIST: { key: AdminModule; label: string }[] = [
  { key: "dashboard", label: "대시보드" },
  { key: "user_management", label: "사용자 관리" },
  { key: "agent_management", label: "에이전트 관리" },
  { key: "project_management", label: "프로젝트 관리" },
  { key: "inquiry_management", label: "문의 관리" },
  { key: "ax_trend_hub", label: "AX Trend Hub" },
  { key: "admin_management", label: "관리자 관리" },
];

// API format: read / create / update / delete
const PERMISSION_ACTIONS: { key: PermissionAction; label: string }[] = [
  { key: "read", label: "조회" },
  { key: "create", label: "등록" },
  { key: "update", label: "수정" },
  { key: "delete", label: "삭제" },
];

interface PermissionMatrixCardProps {
  role: IAdminRole | "";
}

export const PermissionMatrixCard = ({ role }: PermissionMatrixCardProps) => {
  const permissions = role ? PERMISSION_MATRIX[role] : undefined;

  return (
    <div className="bg-white rounded p-5 flex flex-col gap-6 border border-[#00000017]">
      <h2 className="text-xl font-bold text-[#202020]">권한</h2>

      {/* Permissions Table */}
      <div className="border border-[#00000017] rounded overflow-hidden">
        {/* Header */}
        <div className="flex bg-[#EBEBEB]">
          <div className="w-[242px] px-3 py-3">
            <span className="text-xs text-[#000000]">모듈</span>
          </div>
          {PERMISSION_ACTIONS.map(({ key, label }) => (
            <div key={key} className="flex-1 px-3 py-3 text-center">
              <span className="text-xs text-[#000000]">{label}</span>
            </div>
          ))}
        </div>

        {/* Rows */}
        {PERMISSIONS_LIST.map(({ key: moduleKey, label }) => (
          <div key={moduleKey} className="flex border-t border-[#00000017]">
            <div className="w-[242px] px-3 py-3">
              <span className="text-base text-[#000000]">{label}</span>
            </div>
            {PERMISSION_ACTIONS.map(({ key: actionKey }) => {
              const allowed = permissions?.[moduleKey] ?? [];
              const hasPermission = allowed.includes(actionKey);
              return (
                <div key={actionKey} className="flex-1 px-3 py-3 flex justify-center">
                  {hasPermission ? <Check width={24} height={24} color="#FD5108" /> : null}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
